module.exports = __webpack_public_path__ + "img/keplr.177f8195.svg";